import { render, staticRenderFns } from "./TableDataManagementModal.vue?vue&type=template&id=2c10605a&lang=true&"
import script from "./TableDataManagementModal.vue?vue&type=script&lang=js&"
export * from "./TableDataManagementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports